export const actionNames = {
  blockDay: 'blockDay',
  unblockDay: 'unblockDay',
  addDayIntervals: 'addDayIntervals',
  deleteDayIntervals: 'deleteDayIntervals',
  uploadDayRecords: 'uploadDayRecords',
  blockDesk: 'blockDesk',
  unblockDesk: 'unblockDesk',
  addDeskIntervals: 'addDeskIntervals',
  deleteDeskIntervals: 'deleteDeskIntervals',
  blockInterval: 'blockInterval',
  unblockInterval: 'unblockInterval',
  deleteInterval: 'deleteInterval',
  registration: 'registration',
  reRegistration: 'reRegistration',
  selectIntervalForReRegistration: 'selectIntervalForReRegistration',
  clearInterval: 'clearInterval',
  updateRegistration: 'updateRegistration',
};

export const deletableCalendarEntityKeys = {
  day: 'day',
  desk: 'desk',
  interval: 'interval',
};
